import { call, put, takeLatest } from 'redux-saga/effects';
import { UPDATE_TENANT_CONFIG } from '../constants';
import invokeApi from '../network';
import networkConfig from '../network/config';
import { tenantConfigUpdateError, tenantConfigUpdateSuccess } from '../redux/Actions/TenantAction';
import { setErrorCode } from '../redux/Actions/ErrorAction';
export function* getTenantConfigUpdate(request) {
    try {
        const { tenantId = '', platform } = request.request;
        const headers = { 'x-tenant-id': tenantId };
        const { response, status } = yield call(invokeApi, networkConfig.tenantConfigUpdate, null, headers, null);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put(tenantConfigUpdateSuccess({ ...response, platform }));
        }
        else {
            yield put(tenantConfigUpdateError());
        }
    }
    catch (error) {
        yield put(tenantConfigUpdateError(error));
    }
}
export function* tenantConfigUpdateSaga() {
    yield takeLatest(UPDATE_TENANT_CONFIG, getTenantConfigUpdate);
}
